import React, {Fragment} from 'react'
import ApiTokenPanel from '../components/apiTokenPanel'

const ApiToken = () => (
    <Fragment>
        <ApiTokenPanel />
    </Fragment>
)

export default ApiToken


// WEBPACK FOOTER //
// ./src/views/Setup/ApiToken/container/index.js